module.exports = __webpack_public_path__ + "img/ywDark.60437234.png";